var map = {
	"./ar.json": 5310,
	"./base.it.json": 1911,
	"./bg.json": 4378,
	"./cs.json": 3571,
	"./de.json": 5894,
	"./el.json": 4524,
	"./en.json": 4174,
	"./es.json": 6725,
	"./fr.json": 4605,
	"./hr.json": 6759,
	"./hu.json": 6938,
	"./it.json": 3672,
	"./nl.json": 4943,
	"./pl.json": 1029,
	"./pt.json": 7741,
	"./ro.json": 2354,
	"./ru.json": 4600,
	"./sk.json": 347,
	"./sl.json": 7110,
	"./sq.json": 8141,
	"./sr.json": 8912,
	"./tr.json": 9755,
	"./uk.json": 2749,
	"./zh-CN.json": 731,
	"./zh-TW.json": 1507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1360;